/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import { AUTH_USER_PROPERTY } from '../store/auth/auth.config';

/**
 * Verifica si el usuario actual tiene los permisos requeridos definidos en la data de la ruta.
 * Los permisos se definen en `route.data['permissions']` como un array de arrays de strings,
 * donde cada subarray es una ruta al permiso booleano dentro del objeto User.
 * E.g., [['userType', 'userRead'], ['userType', 'userCreate']]
 */
export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const permissionsService = inject(PermissionsService);
  const userProperty = inject(AUTH_USER_PROPERTY, { optional: true });

  const requiredPermissions = route.data['permissions'] as string[][];

  const hasAllPermissions = permissionsService.hasPermissions(requiredPermissions);

  if (hasAllPermissions) {
    return true;
  } else {
    if (userProperty === 'userAdmin') {
      router.navigate(['/account/residential-developments']);
    } else {
      router.navigate(['/account/dashboard']); // Redirigir a la página de inicio o a una de 'acceso denegado'
    }
    return false;
  }
};
